import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Contact\GetContactWithRelationsController::__invoke
* @see app/Http/Controllers/Contact/GetContactWithRelationsController.php
* @route '/api/contact/{mergeableContact}/relations'
*/
const GetContactWithRelationsController = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactWithRelationsController.url(args, options),
    method: 'get',
})

GetContactWithRelationsController.definition = {
    methods: ["get","head"],
    url: '/api/contact/{mergeableContact}/relations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Contact\GetContactWithRelationsController::__invoke
* @see app/Http/Controllers/Contact/GetContactWithRelationsController.php
* @route '/api/contact/{mergeableContact}/relations'
*/
GetContactWithRelationsController.url = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mergeableContact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { mergeableContact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            mergeableContact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mergeableContact: typeof args.mergeableContact === 'object'
        ? args.mergeableContact.id
        : args.mergeableContact,
    }

    return GetContactWithRelationsController.definition.url
            .replace('{mergeableContact}', parsedArgs.mergeableContact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Contact\GetContactWithRelationsController::__invoke
* @see app/Http/Controllers/Contact/GetContactWithRelationsController.php
* @route '/api/contact/{mergeableContact}/relations'
*/
GetContactWithRelationsController.get = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactWithRelationsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Contact\GetContactWithRelationsController::__invoke
* @see app/Http/Controllers/Contact/GetContactWithRelationsController.php
* @route '/api/contact/{mergeableContact}/relations'
*/
GetContactWithRelationsController.head = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetContactWithRelationsController.url(args, options),
    method: 'head',
})

export default GetContactWithRelationsController